export default __webpack_public_path__ + "static/media/ivy_logo.4e0fafe5.png";